module.exports = __webpack_public_path__ + "static/media/hi.8b9edb80.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/hi.mp3
// module id = 738
// module chunks = 0